export default __webpack_public_path__ + "static/femme-cercle-d43e889ef1b4e805f22f8e0a8448532d.png";